import { useContext } from 'react';
import { BRANCHES_TABLE_MODEL } from './branches.model';
import MetricsInspectionContext from '../../../state/context';
import { getParamKeysByMetricName } from '../../useActivityData/utils';
import { getTotalEntitiesStr } from '../../../Charts/ScatterChart/Header';
import { metricNames } from '@linearb/linjs-common';

const useCols = ({ data } = {}) => {
  const {
    state: { widget, metricName }
  } = useContext(MetricsInspectionContext);
  const widgetName = widget?.name || '';

  const totalBranchesStr = getTotalEntitiesStr(data?.total);
  const { orderByKey } = getParamKeysByMetricName(metricName);

  const cols = [
    {
      dataPoint: BRANCHES_TABLE_MODEL.NAME_CELL,
      name: `${totalBranchesStr} BRANCHES`
    },
    {
      dataPoint: BRANCHES_TABLE_MODEL.REPOS_CELL,
      name: 'REPOS'
    },
    {
      dataPoint: BRANCHES_TABLE_MODEL.AUTHORS_CELL,
      name: 'CONTRIBUTORS'
    },
    {
      dataPoint: BRANCHES_TABLE_MODEL.PR_ISSUER_CELL,
      name: 'PR ISSUER'
    },
    {
      dataPoint: BRANCHES_TABLE_MODEL.STATE_CELL,
      name: 'STATE'
    },
    ...(metricName === metricNames.CYCLE_TIME
      ? [
          {
            dataPoint: BRANCHES_TABLE_MODEL.ACCOUNTED_CYCLE_TIME_VALUE_CELL,
            name: 'CYCLE TIME (ACCOUNTED)',
            isSortedCol: false
          }
        ]
      : []),
    {
      dataPoint: BRANCHES_TABLE_MODEL.METRIC_VALUE_CELL,
      name: widgetName.toUpperCase(),
      sortPoint: orderByKey,
      isSortedCol: true
    }
  ];
  return cols;
};

export default useCols;
